<template>
  <div id="index">
    <!-- <div class="lang">
          <div class="change-lang" @click="changeLangEvent()">{{changeLang}}</div>
      </div> -->
    <div class="headPC">
      <!-- <div class="lang">
      <div class="change-lang" @click="changeLangEvent()">{{changeLang}}</div>
    </div> -->
      <div class="Nav">
        <router-link to="/"
          ><img
            class="TopLOGO"
            src="/static/images/logo20230410.png"
            alt="头部LOGO"
        /></router-link>
        <div class="menu" v-if="$route.name != 'Building'">
          <router-link class="menu-item" to="/">{{
            $t("message.sy")
          }}</router-link
          ><!--
          --><a
            class="menu-item"
            v-if="AccessToken"
            :href="
              'http://kf.xygl.sjtu.edu.cn/IM/Web/index.html?UID=' +
              UID +
              '&NAME=' +
              NAME
            "
            target="_blank"
            >{{ $t("message.zxkf") }}</a
          ><!--
          <router-link class="menu-item"  to="/ServiceType">{{$t('message.wypj')}}</router-link>-->
          <router-link class="menu-item" to="/DataPublic">{{
            $t("message.sjgk")
          }}</router-link>
          <!--<router-link class="menu-item"  to="/LostFind">{{$t('message.swzl')}}</router-link>-->
          <a
            class="menu-item"
            v-if="!AccessToken"
            :href="
              'https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=essential&client_id=N7WGL0JVqs3IiSJGdP4A&redirect_uri=' +
              redirectUrl
            "
            >{{ $t("message.dl") }}</a
          >
          <el-dropdown
            class="menu-item"
            :show-timeout="0"
            v-if="AccessToken && userName != ''"
          >
            <a class="menu-item">{{ userName }}</a>
            <el-dropdown-menu slot="dropdown" class="exitDropdown">
              <a class="el-dropdown-menu__item" @click="exit">{{
                $t("message.tc")
              }}</a
              ><br />
              <!-- <a class="el-dropdown-menu__item" href="http://admin.weixiao.ct-study.com.cn">{{$t('message.htdl')}}</a> -->
              <a
                class="el-dropdown-menu__item"
                href="https://admin.feedback.sjtu.edu.cn/admin/auth/login"
                >{{ $t("message.htdl") }}</a
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <a class="menu-item"  v-if="!AccessToken" href="http://admin.weixiao.ct-study.com.cn">{{$t('message.htdl')}}</a> -->
          <a
            class="menu-item"
            v-if="!AccessToken"
            href="https://admin.feedback.sjtu.edu.cn/admin/auth/login"
            >{{ $t("message.htdl") }}</a
          >
        </div>
      </div>
      <div class="searchDIV" v-if="true">
        <div class="middle-box">
          <i class="iconfont icon-phone"></i
          ><!--
     -->
          <p class="searchDIVmiddle">
            {{ $t("message.shfwrx") }}:<span style="margin-left: 18px"
              >021-54741234</span
            ><br /><span class="time"
              >{{ $t("message.rgkfsj") }} ({{ $t("message.fdjjr") }})</span
            >
          </p>
        </div>
      </div>
      <div class="headBackground"></div>
    </div>
    <router-view></router-view>
    <div class="footerPC">
      <div class="footerPC-inner">
        <img
          class="bottomLOGO"
          src="/static/images/BottomLOGO.png"
          alt="底部LOGO"
        />
        <div class="bottomRight">
          <p class="copyright">
            沪ICP备05052060号-1<span style="margin-left: 24px">{{
              $t("message.bqsy")
            }}</span>
          </p>
          <p class="ContactUs">
            {{ $t("message.dzshs")
            }}<span style="margin-left: 18px">{{ $t("message.ybh") }}</span>
          </p>
          <!-- <p class="Support"><a href="https://admin.weixiao.ct-study.com.cn">管理员后台登录入口</a></p> -->
          <p class="Support">{{ $t("message.ch") }}: 86-21-54740000</p>
        </div>
      </div>
      <van-notice-bar
        v-if="showResult"
        class="result"
        scrollable
        :text="$t('message.lalala1')"
      />
    </div>
    <!-- <div class="new">

    </div> -->
    <div class="modal-backdrop" v-if="first">
      <div class="modal">
        <img class="newphoto" src="/static/images/new.png" />
        <img @click="close" class="close" src="/static/images/close.png" />
      </div>
    </div>
  </div>
</template>

<script>
  import { getAccessToken, removeAccessToken } from "@/utils/auth";
  import { Base64 } from "js-base64";
  export default {
    name: "index",
    data: function () {
      return {
        AccessToken: "",
        userName: "",
        UID: "",
        NAME: "",
        HOST: process.env.HOST,
        redirectUrl: "",
        URL: "",
        showResult: false,
        lang: "zh-CN",
        changeLang: "English",
        first: true,
        choose: "",
        lang: "zh-CN",
        changeLang: "English",
      };
    },
    mounted() {
      // 获取时间
      let month = new Date().getMonth() + 1; //注意！月份是从0月开始获取的，所以要+1;
      let day = new Date().getDate(); //日
      if (month == 8 && day >= 25 && day <= 31) {
        this.first = true;
      } else if (month == 9 && day > 0 && day <= 15) {
        this.first = true;
      } else {
        this.first = false;
      }

      if (this.$route.name == "LostFind") {
        this.showResult = true;
      } else {
        this.showResult = false;
      }
    },
    created() {
      switch (this.HOST) {
        case "dev":
          this.redirectUrl = "http://weixiao.ct-study.com.cn";
          this.URL = "http%3A%2F%2Fweixiao.ct-study.com.cn";
          break;
        case "prod":
          this.redirectUrl = "https://feedback.sjtu.edu.cn";
          this.URL = "https%3A%2F%2Ffeedback.sjtu.edu.cn";
          break;
        case "test":
          this.redirectUrl = "http://weixiao.ct-study.com.cn";
          this.URL = "http%3A%2F%2Fweixiao.ct-study.com.cn";
          break;
        // https://localhost
      }
      this.AccessToken = getAccessToken();
      if (this.AccessToken || this.AccessToken === 0) {
        this.$store.dispatch("getUserInfo").then((res) => {
          this.userName = res.name;
          this.UID = Base64.encode(res.card_number);
          this.NAME = Base64.encode(res.name);
        });
      }
    },
    methods: {
      changeLangEvent() {
        if (this.changeLang == "Chinese") {
          this.changeLang = "English";
        } else {
          this.changeLang = "Chinese";
        }
        if (this.lang === "zh-CN") {
          this.lang = "en-US";
          this.$i18n.locale = this.lang;
        } else {
          this.lang = "zh-CN";
          this.$i18n.locale = this.lang;
        }
      },
      exit() {
        removeAccessToken();
        this.$message({
          message: "成功退出",
          type: "success",
        });
        this.$store.dispatch("commitNowPath", this.$route.fullPath).then(() => {
          window.location.href =
            "https://jaccount.sjtu.edu.cn/oauth2/logout?client_id=N7WGL0JVqs3IiSJGdP4A&retUrl=https%3A%2F%2Ffeedback.sjtu.edu.cn";
        });
      },
      close() {
        this.first = false;
      },
    },
    watch: {
      $route: function (val, oldval) {
        this.AccessToken = getAccessToken();
        if (this.AccessToken || this.AccessToken === 0) {
          this.$store.dispatch("getUserInfo").then((res) => {
            this.userName = res.name;
          });
        }
        if (val.name == "LostFind") {
          this.showResult = true;
        } else {
          this.showResult = false;
        }
      },
    },
  };
</script>

<style lang="scss">
  .exitDropdown {
    padding: 0 !important;
    margin-top: 6px !important;
    .el-dropdown-menu__item {
      color: #282828 !important;
      padding: 0 10px !important;
      line-height: 30px !important;
      display: inline-block !important;
    }
    .el-dropdown-menu__item:hover {
      // background: #fff !important;
      color: #66b1ff !important;
    }
  }
  #index {
    position: relative;
    padding-top: 200px;
    padding-bottom: 154px;
    background-color: #f6f6f6;
    min-height: calc(100vh - 354px);
    // .lang{
    //   position: absolute;
    //   right: 20px;
    //   top: 10px;
    //   color: #fff;
    //   cursor: pointer;
    //   z-index: 999;
    // }
    .lang {
      position: absolute;
      right: 20px;
      top: 10px;
      color: #fff;
      cursor: pointer;
      z-index: 999;
    }
    .headPC {
      top: 0px;
      z-index: 2;
      height: 200px;
      padding: 0 40px;
      position: absolute;
      width: calc(100% - 80px);
      .Nav {
        width: 100%;
        margin: 0 auto;
        padding-top: 20px;
        // max-width: 1320px;
        // min-width: 1120px;
        width: 1200px;
        position: relative;
        .TopLOGO {
          height: 60px;
        }
        .menu {
          top: 42px;
          right: 0px;
          position: absolute;
          .menu-item {
            color: #fff;
            cursor: pointer;
            vertical-align: top;
            display: inline-block;
            font-size: 16px !important;
          }
          .menu-item + .menu-item {
            margin-left: 20px;
          }
        }
      }
      .searchDIV {
        width: 1200px;
        height: 98px;
        max-width: 1320px;
        min-width: 1120px;
        text-align: center;
        border-radius: 6px;
        position: relative;
        white-space: nowrap;
        margin: 39px auto 0 auto;
        background-color: #ffffff;
        -webkit-border-radius: 6px;
        box-shadow: 0px 3px 7px rgba(4, 0, 0, 0.11);
        -webkit-box-shadow: 0px 3px 7px rgba(4, 0, 0, 0.11);
        .middle-box {
          display: inline-block;
          .icon-phone {
            color: #0086d1;
            font-size: 52px;
            margin-top: 22px;
            vertical-align: top;
            display: inline-block;
          }
          .searchDIVmiddle {
            color: #0086d1;
            font-size: 26px;
            margin-top: 24px;
            line-height: 26px;
            margin-left: 18px;
            vertical-align: top;
            text-decoration: none;
            display: inline-block;
            .time {
              color: #606060;
              font-size: 14px;
              overflow: hidden;
              text-align: center;
            }
          }
        }

        .verticalLine {
          width: 1px;
          height: 78px;
          margin-top: 10px;
          margin-left: 20px;
          vertical-align: top;
          display: inline-block;
          background-color: #0086d1;
        }
        .searchInput {
          height: 56px;
          margin-top: 20px;
          margin-left: 20px;
          padding: 0 20px;
          font-size: 16px;
          vertical-align: top;
          display: inline-block;
          width: calc(100% - 664px);
          border: 1px solid #f0f0f0;
          background-color: #f6f6f6;
        }
        .searchButton {
          border: none;
          color: #0086d1;
          font-size: 22px;
          margin-top: 20px;
          line-height: 58px;
          vertical-align: top;
          display: inline-block;
          padding: 0 40px 0 30px;
          background-color: #fff;
        }
      }
      .headBackground {
        top: 0px;
        left: 0px;
        width: 100%;
        z-index: -1;
        min-width: 1200px;
        padding-top: 200px;
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url("/static/images/TopBanner.jpg");
      }
    }
    .footerPC {
      bottom: 0px;
      height: 154px;
      padding: 0 40px;
      position: absolute;
      width: calc(100% - 80px);
      background-color: #0086d1;
      .footerPC-inner {
        margin: 0 auto;
        max-width: 1320px;
        min-width: 1120px;
        position: relative;
        .bottomLOGO {
          height: 98px;
          margin-top: 28px;
          margin-left: 18px;
        }
        .bottomRight {
          top: 32px;
          right: 0px;
          color: #fff;
          font-size: 14px;
          text-align: right;
          line-height: 30px;
          position: absolute;
          // .copyright{

          // }
          // .ContactUs{

          // }
          // .Support{

          // }
        }
      }
      .result {
        color: #fff;
        height: 20px;
        margin: 0 auto;
        max-width: 1320px;
        min-width: 1120px;
        background-color: transparent;
        font-size: 14px;
        overflow: hidden;
        text-align: center;
      }
    }
    .new {
      position: fixed;
      top: 0;
      width: 100%;
      height: 100%;
      // background-color: red;
      z-index: 999999;
    }
    .modal-backdrop {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      align-items: center;
      z-index: 999;
    }
    .modal {
      background-color: #fff;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 16px;
      width: 700px;
      .close {
        position: absolute;
        top: 20%;
        right: 23%;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue


// WEBPACK FOOTER //
// src/views/index/index.vue